<script setup>
defineProps(['model'])

function scrollToContactForm() {
  const el = document.getElementById('contactForm')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<template>
  <div
    class="call-to-action block-spacing"
    :class="[
      { 'call-to-action--narrow-width': model?.width?.value !== 'full-width' },
      { 'call-to-action--full-width': model?.width?.value === 'full-width' },
      { 'call-to-action--navy dark-bg': model?.color?.value === 'navy' },
    ]"
  >
    <div class="container-fluid">
      <div class="call-to-action__grid rounded-xl">
        <div class="call-to-action__icon-wrap">
          <NuxtImg
            v-if="model?.aprimoIcon?.url"
            provider="fastlyAprimo"
            :src="model?.aprimoIcon?.url"
            class="call-to-action__icon"
            :width="model?.aprimoIcon?.width ?? 90"
            :height="model?.aprimoIcon?.height ?? 90"
            loading="lazy"
            :alt="model?.iconAltText?.value"
          />
        </div>
        <div class="call-to-action__content-wrap prose">
          <div class="call-to-action__content">
            <h2
              v-if="model?.title?.value"
              class="mt-0"
            >
              {{ model.title.value }}
            </h2>
            <div v-html="model?.body?.value" />
          </div>
          <UButton
            v-if="model?.linkItem?.value"
            v-bind="model?.isScrollToForm?.value ? {} : { to: useCmsUrl(model.linkItem.value.href), locale: false }"
            :color="model?.color?.value === 'navy' ? 'info' : 'warning'"
            variant="solid"
            :size="model?.width?.value !== 'full-width' ? 'lg' : undefined"
            class="mt-7.5 md:mt-0 btn justify-center no-underline w-full md:w-auto cursor-pointer"
            @click="model?.isScrollToForm?.value && scrollToContactForm()"
          >
            {{ model.linkItem.value.text }}
          </UButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/call-to-action-block.scss';
</style>
